var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 161,
    viewBox: "0 0 153 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.0411L76.5 7.59131L153 71.0411V160.815H0V71.0411Z",
    fill: "#94B46F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.038 124.818H24.9751C24.2036 124.818 23.5781 124.192 23.5781 123.42V22.0451C23.5781 21.2741 24.2036 20.6487 24.9751 20.6487H128.038C128.809 20.6487 129.434 21.2741 129.434 22.0451V123.42C129.434 124.192 128.809 124.818 128.038 124.818Z",
    fill: "#F1F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.038 20.6482H24.9751C24.2036 20.6482 23.5781 21.2736 23.5781 22.0446V23.082C23.5781 22.3105 24.2036 21.6845 24.9751 21.6845H128.038C128.809 21.6845 129.434 22.3105 129.434 23.082V22.0446C129.434 21.2736 128.809 20.6482 128.038 20.6482Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.082 34.0037H69.5312V39.5563H116.082V34.0037Z",
    fill: "#D7DADB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.082 44.9685H69.5312V50.5211H116.082V44.9685Z",
    fill: "#D7DADB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4209 34.0037H36.9375V61.4865H64.4209V34.0037Z",
    fill: "#C0DD9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.082 55.9333H69.5312V61.4865H116.082V55.9333Z",
    fill: "#D7DADB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 66.8987H36.9375V72.4519H116.084V66.8987Z",
    fill: "#D7DADB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 88.8293H36.9375V94.382H116.084V88.8293Z",
    fill: "#D7DADB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 77.8633H36.9375V83.4165H116.084V77.8633Z",
    fill: "#D7DADB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 99.7942H36.9375V105.347H116.084V99.7942Z",
    fill: "#D7DADB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 110.76H36.9375V116.313H116.084V110.76Z",
    fill: "#D7DADB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.041L63.4392 115.928L0 160.815V71.041Z",
    fill: "#C0DD9D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 71.041V71.9201L62.1973 115.928L0 159.936V160.815L63.4392 115.928L0 71.041Z",
    fill: "#C0DD9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.002 71.041L89.5625 115.928L153.002 160.815V71.041Z",
    fill: "#C0DD9D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.002 71.041V71.9201L90.805 115.928L153.002 159.936V160.815L89.5625 115.928L153.002 71.041Z",
    fill: "#C0DD9D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6137 115.928H63.4392V115.891L0 160.815H153L89.6137 115.928Z",
    fill: "#B0CA93"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_599_6171)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.768,
    cy: 29.7145,
    r: 21.7365,
    fill: "#F99587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.657 18.8872C112.616 18.9696 112.593 19.0594 112.588 19.1511C112.584 19.2428 112.598 19.3345 112.63 19.4205C112.662 19.5065 112.712 19.585 112.776 19.6512C112.839 19.7173 112.916 19.7698 113 19.8053L115.145 20.7499C115.504 20.9079 115.92 20.74 116.123 20.4045C117.108 18.8019 118.826 18.0744 120.911 18.9926C122.694 19.7781 123.934 21.3889 122.99 23.5339C122.263 25.1849 120.956 25.5159 118.911 25.9936C116.601 26.4944 114.562 27.3687 113.599 29.8224L113.359 30.39C113.286 30.5618 113.284 30.7552 113.353 30.9284C113.422 31.1016 113.556 31.2408 113.727 31.3159L115.836 32.2445C116.008 32.3204 116.203 32.3247 116.379 32.2565C116.555 32.1883 116.696 32.0531 116.772 31.8807L116.892 31.6077C117.714 29.7409 118.663 29.5101 121.219 28.9005C123.333 28.394 125.572 27.7847 126.808 24.9793C128.538 21.0507 126.056 17.6918 122.424 16.0923C119.13 14.6416 114.845 14.5864 112.657 18.8872ZM110.106 35.6536C109.496 37.0394 110.15 38.5504 111.671 39.2202C113.254 39.9175 114.795 39.3728 115.405 37.987C116.037 36.5518 115.389 35.0621 113.806 34.3649C112.288 33.6962 110.738 34.2184 110.106 35.6536Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_599_6171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.0208,
    height: 45.0208,
    fill: "white",
    transform: "translate(105.492) rotate(23.7675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotificationIcon);
export default __webpack_public_path__ + "static/media/NoNotificationIcon.89141e5c3efea0933c2e47878199c202.svg";
export { ForwardRef as ReactComponent };